<template>
    <form @submit.prevent="login" class="mt-8">
        <input-group name="email" v-model="form.email" type="email" icon="mail" :label="$t('general.email')"
                     autocomplete="username" :form="form"/>
        <input-group name="password" v-model="form.password" type="password" icon="lock-closed"
                     :label="$t('auth.password')" :form="form" autocomplete="current-password"
                     class="mt-4"/>

        <div class="mt-6 flex items-center justify-between">
            <checkbox v-model="form.remember" name="remember" :label="$t('auth.remember_me')"/>

            <div class="text-sm leading-5">
                <span
                    class="font-medium text-green-600 hover:text-green-500 focus:outline-none focus:underline transition cursor-pointer"
                    @click="$emit('change-mode', 'forgot')">
                    {{ $t('auth.forgot_password') }}
                </span>
            </div>
        </div>

        <default-button type="submit" color="green" icon="lock-closed" :loading="form.processing"
                        class="mt-6" block>
            {{ $t('auth.login') }}
        </default-button>
    </form>
</template>

<script>
export default {
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            }),
        };
    },

    methods: {
        login() {
            this.form.post(this.route('login'));
        },
    },
};
</script>
